import React, { useState, useEffect, useRef } from "react";

import moment from "moment/moment";
// import "../CourseList.scss";
// import { DateRange } from "react-date-range";
// import "react-date-range/dist/styles.css";
// import "react-date-range/dist/theme/default.css";
import OverlayContainer from ".././Overlay/OverlayContainer";
// import Forms from "./Forms";
// import Pagination from "./Pagination";
import "./Teachers/CourseList.scss";
import editIcon from "../../assets/icons/icon-edit.svg";
import deleteIcon from "../../assets/icons/icon-delete.svg";
import { CourseBuilderStaticData } from "../../_constants/staticData";
import { Loading } from "../Other/Loading";
import axiosInstance from "../../axios";
import Pagination from "./Teachers/MemberList/Pagination";
import "../Front/front.scss";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import Forms from "./Forms";
import "../Other/CustomAlert/CustomAlert";
import { downloadCSV } from "../Other/utilities";

function MemberList() {
  const [instructorData, setInstructorData] = useState([]);
  const [instructorStats, setInstructorStats] = useState();
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [instructorId, setInstructorId] = useState(0);
  const [dateRangePicker, setDateRangePicker] = useState(false);
  const [dateToggle, setDateToggle] = useState(false);
  const [editInstructorData, setEditInstructorData] = useState([]);
  const [filter, setFilter] = useState({
    status: "",
    startDate: "",
    endDate: "",
    page: 1,
    itemsPerPage: 10,
  });
  const [page, setPage] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [accountLength, setAccountLength] = useState([]);

  const staticData = [
    {
      name: "Total Instructors",
      total: instructorStats?.totalInstructors || "0",
      boxShadow: "Dashboard-color-one",
      color: "color-one",
    },
    {
      name: "Pending Request",
      total: instructorStats?.pendingVerification || "0",
      boxShadow: "Dashboard-color-two",
      color: "color-two",
    },
    {
      name: "Without Course",
      total: instructorStats?.withNotPublishedCourse || "0",
      boxShadow: "Dashboard-color-three",
      color: "color-three",
    },
    {
      name: "Self Created",
      total: "0",
      boxShadow: "Dashboard-color-four",
      color: "color-four",
    },
  ];

  //  to handle date picker
  const refOne = useRef(null);

  const fetch = () => {
    axiosInstance
      .get(
        `user/teacher?status=${filter.status}&page=${filter.page}&perPage=${filter.itemsPerPage}&startDate=${filter.startDate}&endDate=${filter.endDate}`
      )
      .then((res) => {
        setLoading(false);
        setInstructorData(res.data?.data?.data);
        setPage(res.data.data.total_page);
        setAccountLength(res.data.data);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };

  useEffect(() => {
    axiosInstance
      .get(`admin/instructor-statistics`)
      .then((res) => {
        setInstructorStats(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    fetch();
    document.addEventListener("keydown", hideOnEscape, true);
    document.addEventListener("click", hideOnClickOutside, true);
  }, [filter, modal, confirmDelete]);

  const handleSelectChange = (e) => {
    setFilter({ ...filter, itemsPerPage: e.target.value });
  };

  const [range, setRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const hideOnEscape = (e) => {
    if (e.key === "Escape") {
      setDateToggle(false);
    }
  };

  const hideOnClickOutside = (e) => {
    if (refOne.current && !refOne.current.contains(e.target)) {
      setDateToggle(false);
    }
  };

  const handleStatusFilter = (e) => {
    setFilter({ ...filter, status: e.target.value });
  };
  const handleDateRangeFilter = (item) => {
    setFilter({
      ...filter,
      startDate: moment(item.selection.startDate).format("YYYY-MM-D"),
      endDate: moment(item.selection.endDate).format("YYYY-MM-D"),
    });
    setRange([item.selection]);
  };

  const deleteInstructor = (UserId) => {
    setConfirmDelete(true);
    setInstructorId(UserId);
  };

  const handleDeleteInstructor = () => {
    axiosInstance
      .post(`admin/user/delete/`, {
        userId: instructorId,
      })
      .then((res) => {
        if (res) {
          setConfirmDelete(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setConfirmDelete(false);
      });
  };

  const handleEditInstructor = (data) => {
    setModal(true);
    setEditInstructorData(data);
  };

  const handleAddInstructor = () => {
    setModal(true);
    setEditInstructorData([]);
  };

  const handleInstructorList = () => {
    axiosInstance
      .get(`/admin/export/instructors`)
      .then((res) => {
        downloadCSV(res?.data, "Instructor-list");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="width-0">
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="dashboard-container-new">
            <p>Instructor List</p>
            <div>
              <button className="lastmonth-btn">Last Month</button>
              <button className="export-btn" onClick={handleInstructorList}>
                Export
              </button>
            </div>
          </div>
          <div className="flex-dashboard-new-1">
            {staticData.map((item, index) => (
              <div className={`box-shadow-06 ${item.boxShadow}`} key={index}>
                <p className="font-custom-p">{item.name}</p>
                <p className={`font-increase ${item.color}`}>{item.total}</p>
              </div>
            ))}
          </div>
          <div className="page-data-new">
            <div>
              {instructorData?.length > 0 ? (
                <p className="showing-result">
                  Showing {filter.page} page of {filter.itemsPerPage} results
                </p>
              ) : (
                <p className="showing-result">Showing 0 result</p>
              )}
            </div>

            <div className="pagination-flex">
              <div className=" margin-r-n-15">
                <button onClick={handleAddInstructor} className="export-btn">
                  Add <span>&#10009;</span>
                </button>
              </div>
              <div className="pagination-date">
                {dateRangePicker === false ? (
                  <>
                    <input
                      type="text"
                      placeholder="Date Range"
                      className="date-ranger-instructor"
                      onClick={() => {
                        setDateRangePicker(true);
                        setDateToggle(true);
                      }}
                    />
                  </>
                ) : (
                  <input
                    type="text"
                    value={`${moment(range[0].startDate).format(
                      "MM/DD/YYYY"
                    )} to ${moment(range[0].endDate).format("MM/DD/YYYY")}`}
                    placeholder="Date Range"
                    className="date-ranger-instructor-updated"
                    onClick={() => setDateToggle(true)}
                  />
                )}

                <div className="dateWrap" ref={refOne}>
                  {dateToggle && (
                    <DateRange
                      onChange={(item) => handleDateRangeFilter(item)}
                      editableDateInputs={true}
                      moveRangeOnFirstSelection={false}
                      ranges={range}
                      months={1}
                      direction="horizontal"
                      className="dateElement"
                    />
                  )}
                </div>
              </div>
              <div>
                <div className="pagination-select">
                  <select
                    className="select-dropdown-instructor-2"
                    onChange={handleStatusFilter}
                  >
                    <option value="">Select Status</option>
                    <option value="0">Pending</option>
                    <option value="1">Completed</option>
                  </select>
                </div>
              </div>
              <div>
                <p className="item-page-result">Item per page</p>
              </div>
              <div className="pagination-select">
                <select
                  className="select-dropdown-instructor-1"
                  onChange={(e) => handleSelectChange(e)}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={30}>30</option>
                  <option value={40}>40</option>
                  <option value={50}>50</option>
                </select>
              </div>
            </div>
          </div>

          <div className="instructor-table">
            {instructorData?.length === 0 ? (
              <h2 className="no-data-found">No data found</h2>
            ) : (
              <table className="table-width-100">
                <thead>
                  <tr>
                    <th>Sr.no</th>
                    <th>Name</th>
                    <th>User Name</th>
                    <th>Email ID</th>
                    <th>Phone Number</th>
                    <th>Country</th>
                    <th>Register Date</th>
                    <th>Status</th>
                    <th></th>
                  </tr>
                </thead>

                <tbody>
                  {instructorData?.length > 0 ? (
                    instructorData?.map((ele, index) => {
                      return (
                        <tr key={index}>
                          <td className="cell">
                            {filter?.itemsPerPage * filter?.page -
                              filter?.itemsPerPage +
                              index +
                              1}
                          </td>
                          <td className="cell">
                            <div>
                              <img
                                src="https://www.w3schools.com/w3images/avatar2.png"
                                alt=""
                                className="avatar-profile-image-02"
                              />
                              <p>{ele.firstName + " " + ele.lastName}</p>
                            </div>
                          </td>
                          <td className="cell">{ele.userName}</td>
                          <td className="cell">{ele.email}</td>
                          <td className="cell">{ele.phoneNumber}</td>
                          <td className="cell">{ele.countryCode || "-"}</td>
                          <td className="cell">
                            {ele.createdAt
                              ? moment(ele?.createdAt).format("DD/MM/YYYY")
                              : "01/12/22"}
                          </td>
                          <td className="cell">
                            <span
                              style={{
                                backgroundColor: ele.status
                                  ? "#d9f8ff"
                                  : "#f1e1fd",
                              }}
                            >
                              {ele?.status ? "Completed" : "Pending"}
                            </span>
                          </td>
                          <td className="cell">
                            <img
                              onClick={() => handleEditInstructor(ele)}
                              src={editIcon}
                              alt="edit"
                            />
                          </td>
                          <td
                            className="cell"
                            onClick={() => deleteInstructor(ele.id)}
                          >
                            <img src={deleteIcon} alt="delete" />
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <h2 className="no-data-found">No data found</h2>
                  )}
                </tbody>
              </table>
            )}
            {confirmDelete === true && (
              <OverlayContainer>
                <div className="alert-dialog-inner">
                  <div
                    className="alert-dialog-close"
                    onClick={() => setConfirmDelete(!confirmDelete)}
                  >
                    <div>
                      <i className="icon check"></i>
                    </div>
                  </div>
                  <div className="alert-title">Warning!</div>
                  <div className="alert-message">
                    {CourseBuilderStaticData.deleteInstructorOverlay.header}
                  </div>

                  <div className="alert-close-btn">
                    <a className="btn-save" onClick={handleDeleteInstructor}>
                      OK
                    </a>

                    <a
                      className="btn-cancel"
                      onClick={() => setConfirmDelete(false)}
                    >
                      CANCEL
                    </a>
                  </div>
                </div>
              </OverlayContainer>
            )}
          </div>
          {/* Pagination */}
          <div className="pageNumbers-sudents">
            {instructorData?.length >= 0 ? (
              <Pagination
                className="pageNumbers-sudents"
                currentPage={filter.page}
                totalCount={filter.itemsPerPage}
                pageSize={page}
                onPageChange={(page) => setFilter({ ...filter, page: page })}
              />
            ) : (
              ""
            )}{" "}
          </div>

          {modal && (
            <OverlayContainer>
              {/* Limit user warning shown here as per the plan  */}
              {accountLength.total < 177 ? (
                <Forms
                  setModal={setModal}
                  title="Instructor"
                  role={4}
                  editData={editInstructorData}
                />
              ) : (
                <div className="alert-dialog-inner">
                  <div
                    className="alert-dialog-close"
                    onClick={() => setModal(false)}
                  >
                    <div>
                      <i className="icon check"></i>
                    </div>
                  </div>
                  <div className="alert-title">Warning!</div>
                  <div className="alert-message">
                    {
                      "Maximum user account limit reached. If you wish to add another user you have to upgrade your existing plan or delete existing user."
                    }
                  </div>

                  <div className="alert-close-btn">
                    <a className="btn-save" href="https://edusity.com/pricing">
                      UPGRADE PLAN
                    </a>

                    <a className="btn-cancel" onClick={() => setModal(false)}>
                      CANCEL
                    </a>
                  </div>
                </div>
              )}
            </OverlayContainer>
          )}
        </>
      )}
    </div>
  );
}

export default MemberList;
